export default ({
  EPS: 2 ** -37,
});
